<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "BlankLayout",
  mounted() {
    window.isRtl = window.Helpers.isRtl();
    window.isDarkStyle = window.Helpers.isDarkStyle();
  },
};
</script>
